import AccessTokenModelBase from '../_generated/modelBases/access-token-model-base';

export default class AccessTokenModel extends AccessTokenModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
